(function () {
  function apiBase(root) {
    return (root.dataset.apiBase || "https://admin.print-foundry.com").replace(/\/+$/, "");
  }

  function buildUrl(root, path) {
    return apiBase(root) + path;
  }

  function params(root) {
    return new URLSearchParams({
      shop: root.dataset.shop || window.location.hostname,
      customerId: root.dataset.customerId || ""
    });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function editorUrl(root, design) {
    var base = root.dataset.builderUrl || "/pages/build-your-armour";
    var url = new URL(base, window.location.origin);
    url.searchParams.set("designId", design.id || "");
    url.searchParams.set("customerId", root.dataset.customerId || "");
    if (root.dataset.customerEmail) url.searchParams.set("customerEmail", root.dataset.customerEmail);
    return url.pathname + url.search;
  }

  function card(root, design) {
    var preview = design.previewUrl || "";
    return [
      '<article class="pf-saved-design-card">',
      '<a class="pf-saved-design-card__image" href="' + escapeHtml(editorUrl(root, design)) + '">',
      preview ? '<img src="' + escapeHtml(preview) + '" alt="">' : '<span>Design</span>',
      '</a>',
      '<div class="pf-saved-design-card__body">',
      '<h3>' + escapeHtml(design.title || "Saved Design") + '</h3>',
      '<p>' + escapeHtml([design.garmentTitle || design.garmentCode, design.colorName || design.colorCode, design.sizeCode].filter(Boolean).join(" / ")) + '</p>',
      '<div class="pf-saved-design-card__actions">',
      '<a class="button button--primary" href="' + escapeHtml(editorUrl(root, design)) + '">Reorder</a>',
      '<button type="button" class="button button--secondary" data-pf-delete-design="' + escapeHtml(design.id) + '">Delete</button>',
      '</div>',
      '</div>',
      '</article>'
    ].join("");
  }

  function render(root, designs) {
    var list = root.querySelector("[data-pf-designs-list]");
    var countTarget = root.dataset.pfDesignCountTarget
      ? document.querySelector(root.dataset.pfDesignCountTarget)
      : null;
    if (countTarget) countTarget.textContent = String(designs.length);
    if (!list) return;
    if (!designs.length) {
      list.innerHTML = '<div class="account-desc text-left">No saved designs yet.</div>';
      return;
    }
    list.innerHTML = designs.map(function (design) { return card(root, design); }).join("");
  }

  function load(root) {
    var list = root.querySelector("[data-pf-designs-list]");
    if (!root.dataset.customerId) {
      if (list) list.innerHTML = '<div class="account-desc text-left">Log in to save and reorder designs.</div>';
      return;
    }
    if (list) list.innerHTML = '<div class="account-desc text-left">Loading saved designs...</div>';
    fetch(buildUrl(root, "/api/public/armor-builder/designs?" + params(root).toString()), {
      headers: { "Accept": "application/json" },
      credentials: "omit",
      cache: "no-store"
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.error || "Could not load saved designs.");
          return body;
        });
      })
      .then(function (body) {
        render(root, Array.isArray(body.designs) ? body.designs : []);
      })
      .catch(function (error) {
        if (list) list.innerHTML = '<div class="account-desc text-left">' + escapeHtml(error.message || "Could not load saved designs.") + '</div>';
      });
  }

  function init(root) {
    if (root.dataset.pfDesignsInitialized === "true") return;
    root.dataset.pfDesignsInitialized = "true";
    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-pf-delete-design]");
      if (!button) return;
      event.preventDefault();
      var id = button.getAttribute("data-pf-delete-design");
      if (!id || !window.confirm("Delete this saved design?")) return;
      button.disabled = true;
      fetch(buildUrl(root, "/api/public/armor-builder/designs/" + encodeURIComponent(id) + "?" + params(root).toString()), {
        method: "DELETE",
        credentials: "omit"
      }).then(function () {
        load(root);
      }).catch(function () {
        button.disabled = false;
      });
    });
    load(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-pf-saved-designs]").forEach(init);
  });
})();
